module.exports = __webpack_public_path__ + "static/cake_real_flower-d2ff29b95f205dc6852faf687d1c32ea.jpg";